@if (isSortable()) {
    <sh-action-item [item]="sortAction()"></sh-action-item>
}
